import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdAdd, MdOutlineWorkspacePremium, MdOutlineChatBubbleOutline } from "react-icons/md";
import PageLayout from "../../components/layouts/PageLayout";
import CustomNavbar from "../../components/common/CustomNavbar";
import PricingCards from "./PricingCards";
import PricingPerMsg from "./PricingPerMsg";
import { getAuthUser } from "../../util/manageAuth";

type Tab = "plans" | "messages";

export default function Pricing() {
  const navigate = useNavigate();
  const [tab, setTab] = useState<Tab>("plans");
  const isSuperAdmin = getAuthUser()?.role?.toUpperCase() === "ROLE_ADMIN";

  const tabs: [Tab, string, React.ReactNode][] = [
    ["plans", "Plans", <MdOutlineWorkspacePremium size={16} />],
    ["messages", "Message rates", <MdOutlineChatBubbleOutline size={16} />],
  ];

  return (
    <PageLayout
      customNavbar={
        <CustomNavbar>
          <span className="font-bold text-lg">Plans &amp; pricing</span>
        </CustomNavbar>
      }
    >
      <div className="relative overflow-hidden rounded-4xl bg-white">
        {/* soft brand glow behind the heading */}
        <div className="pointer-events-none absolute -top-40 left-1/2 h-80 w-[46rem] -translate-x-1/2 rounded-full bg-[radial-gradient(closest-side,rgba(2,136,209,0.14),transparent)]" />

        <div className="relative flex flex-col items-center gap-8 px-4 py-8 sm:px-8 sm:py-10">
          <div className="flex w-full max-w-6xl flex-wrap items-center justify-between gap-3">
            <div className="inline-flex rounded-full border border-slate-200 bg-white p-1" role="tablist" aria-label="Pricing">
              {tabs.map(([key, label, icon]) => (
                <button
                  key={key}
                  role="tab"
                  aria-selected={tab === key}
                  onClick={() => setTab(key)}
                  className={`flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold transition ${
                    tab === key ? "bg-slate-900 text-white" : "text-slate-500 hover:text-slate-800"
                  }`}
                >
                  {icon}
                  {label}
                </button>
              ))}
            </div>

            {isSuperAdmin && tab === "messages" && (
              <button
                onClick={() => navigate("/admin/pricing/msg/add")}
                className="inline-flex items-center gap-1.5 rounded-full bg-brand-blue-gradient px-5 py-2.5 text-sm font-bold text-white shadow-sm"
              >
                <MdAdd size={18} /> Add rate
              </button>
            )}
          </div>

          <div className="w-full max-w-6xl">{tab === "plans" ? <PricingCards /> : <PricingPerMsg />}</div>
        </div>
      </div>
    </PageLayout>
  );
}
